<mat-card *ngIf="receivedForm == 'formEditNameSite'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ชื่อโรงพยาบาล</mat-label>
      <input matInput placeholder="ชื่อโรงพยาบาลที่ใช้ในการแสดงผล">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditIdSite'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ไอดีโรงพยาบาล</mat-label>
      <input matInput placeholder="ไอดีโรงพยาบาล">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditLogoSite'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>เลือกไฟล์รูปภาพ</mat-label>
      <input matInput readonly="true"  placeholder="เลือกไฟล์รูปภาพ">
    </mat-form-field>
    <button mat-button>Browse</button>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'deleteSite'">
  <h2 mat-dialog-title>ลบโรงพยาบาล</h2>
  <mat-dialog-content>
    <mat-label>
      คุณกำลังทำการลบ โรงพยาบาลนี้ออกจากระบบ หากดำเนินการไปแล้วจะไม่สามารกู้ข้อมูลกลับมาคืนมาได้
    </mat-label>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditNameService'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ชื่อจุดบริการ</mat-label>
      <input matInput placeholder="ชื่อจุดบริการที่ใช้ในการแสดงผล">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditIdService'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ไอดีจุดให้บริการ</mat-label>
      <input matInput placeholder="ไอดีจุดให้บริการ">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditStatusQueue'">
  <mat-dialog-content>
    <mat-label>จำนวนสถานะคิว : </mat-label>
    <br>
    <mat-radio-group class="example-radio-group" >
      <mat-radio-button class="example-radio-button" value="6">
        <mat-label>
          <p>6 สถานะ</p>
          <p>(Queue Receive/ SQ Call/ Check In/ ABS Call/ Pending/ Close)</p>
        </mat-label>
      </mat-radio-button>
      <br>
      <mat-radio-button class="example-radio-button" value="7">
        <mat-label>
          <p>7 สถานะ</p>
          <p>(Queue Receive/ SQ Call/ Queue Scan/ Check In/ ABS Call/ Pending/ Close)</p>
        </mat-label>
      </mat-radio-button>
    </mat-radio-group>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditNotificationQueue'">
  <mat-dialog-content>
    <mat-label>แจ้งเตือนล่วงหน้าก่อนถึงคิว : </mat-label>
    <br>
    <mat-radio-group class="example-radio-group" >
      <mat-radio-button class="example-radio-button" value="6">
        <mat-label>
          <p>3 คิว</p>
        </mat-label>
      </mat-radio-button>
      &nbsp;
      <mat-radio-button class="example-radio-button" value="7">
        <mat-label>
          <p>5 คิว</p>
        </mat-label>
      </mat-radio-button>
      &nbsp;
      <mat-radio-button class="example-radio-button" value="7">
        <mat-label>
          <p>10 คิว</p>
        </mat-label>
      </mat-radio-button>
    </mat-radio-group>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>

</mat-card>
<mat-card *ngIf="receivedForm == 'formEditNotificationMessage'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ข้อความแจ้งเตือน</mat-label>
      <input matInput placeholder="ข้อความแจ้งเตือน">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'deleteService'">
  <h2 mat-dialog-title>ลบจุดบริการ</h2>
  <mat-dialog-content>
    <mat-label>
      คุณกำลังทำการลบ จุดบริการนี้ออกจากระบบ หากดำเนินการไปแล้วจะไม่สามารกู้ข้อมูลกลับมาคืนมาได้
    </mat-label>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditNameUser'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>ชื่อผู้ดูแลระบบ</mat-label>
      <input matInput placeholder="ชื่อผู้ดูแลระบบ">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditEmailUser'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>อีเมลล์</mat-label>
      <input matInput placeholder="อีเมลล์">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditTelUser'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>เบอร์โทรศัพท์</mat-label>
      <input matInput placeholder="เบอร์โทรศัพท์">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'formEditPassUser'">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Password</mat-label>
      <input matInput placeholder="Password">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>
<mat-card *ngIf="receivedForm == 'deleteUser'">
  <h2 mat-dialog-title>ลบผู้ดูแลระบบ</h2>
  <mat-dialog-content>
    <mat-label>
      คุณกำลังทำการลบ ผู้ดูแลระบบนี้ออกจากระบบ หากดำเนินการไปแล้วจะไม่สามารกู้ข้อมูลกลับมาคืนมาได้
    </mat-label>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">บันทึก</button>
  </mat-dialog-actions>
</mat-card>